import React from 'react';
import { Grid, Hidden } from '@material-ui/core';
import SortByDropdown from '../sort-by-dropdown';
import SupportersHeader from '../../../atoms/comments/supporters-header';
import styles from './styles.scss';


interface CommentViewHeaderProps {
    commentCount: number;
    sortType: string;
    sortTypeCallback: (value: string) => void;
}

const CommentViewHeader = function AllCommentsModal({ commentCount, sortType, sortTypeCallback }: CommentViewHeaderProps) {
    return (
        <Grid container spacing={1} className={styles['comment-view-header']}>
            <Grid item xs={12} md={6} lg={4}>
                <SupportersHeader supporterCount={commentCount} />
            </Grid>
            <Hidden mdDown={true}>
                <Grid item lg={4} />
            </Hidden>
            <Grid item xs={12} md={6} lg={4}>
                <SortByDropdown sortType={sortType} selectHandler={sortTypeCallback} />
            </Grid>
        </Grid>
    );
};

export default CommentViewHeader;